export const flood = {
  name: `flood`,
  sql: `
    SELECT * FROM solano_fld
    WHERE haz_fld IN ('100yr', '500yr', 'PROTECTED BY LEVEE')
    `,
  cartoCSS: `
  #layer {
    polygon-fill: ramp([haz_fld], (#FF00C5, #A573D3,  #fcef32), ("100yr", "500yr", "PROTECTED BY LEVEE"), =);
    polygon-opacity: 0.64;
    polygon-comp-op: screen;
  }
  #layer::outline {
      line-width: 0;
      line-color: #FFFFFF;
      line-opacity: 0.5;
  }
  `,
  viz: `
    color: ramp(buckets($haz_fld, ['100yr', '500yr', 'PROTECTED BY LEVEE']), [opacity(#FF00C5, 0.3),opacity(#A573D3, 0.3), opacity(#5D2997, 0.3)])
    strokeWidth: 0
    `
}